import { CheckoutResponse } from '~client/model/checkout-response';
import { reviewResaleListing } from '~web/interactor/resale/review-selling-listing';
import { TaskStore } from '~web/store/base/task-store';

export class SellingCheckoutStore extends TaskStore<CheckoutResponse> {
  initialize(inventoryItemIds: string[], reservePrice: number, oldOfferGroupId?: number): void {
    this.setTask(reviewResaleListing, {
      inventoryItemIds,
      oldOfferGroupId,
      reservePrice,
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/web/src/js/store/selling/selling-checkout-store.ts